import React, { useEffect, useState } from 'react';
import usdaLogoDiagram from 'cd-eft/assets/images/usda-logo-name.png';
import { Table } from 'reactstrap';
import { formatDateTime, formatMonthDayYear, formatMonthDayYear2 } from 'cd-eft/utils/formatDate';
import { emailToName } from 'cd-eft/utils/stringUtilities';
import stores from 'cd-eft/models/Stores';
import './WaterwayDesignReportComponent.scss';
import { observer } from 'mobx-react-lite';

const { waterwayDesignStore } = stores.AppStore;

export const WaterwayDesignReportComponent = observer((props: any) => {
  const getPageMargins = () => {
    return `@page { margin: ${0.5}in !important; }`;
  };

  const [list, setList] = useState([]);
  const [reachList, setReachList] = useState([]);

  useEffect(() => {
    if (props.waterwayVertexParamList || props.linedSoilVegInfoList || props.waterWayDesignReachInfoList) {
      setList(props.waterwayVertexParamList ? props.waterwayVertexParamList : props.linedSoilVegInfoList);
      setReachList(props.waterwayVertexParamList ? props.waterwayVertexParamList : props.waterWayDesignReachInfoList);
    }
  }, [props]);

  return (
    <div className="design-report-container waterway-report page-break">
      <style type="text/css" media="print">
        {'\
        @page { size: landscape; }\
      '}
      </style>
      <style>{getPageMargins()}</style>
      <div className="header">
        <div className="logo">
          <img id="usda-logo" src={usdaLogoDiagram} alt="usda logo" />
        </div>
        <div>
          <div className="date">Report Generated:</div>
          <div>{formatDateTime(new Date())}</div>
        </div>
      </div>
      <div className="form-heading">
        <h1 className="h1">Waterway Design Documentation</h1>
      </div>
      <div className="form-content">
        <div className="form-columns">
          <div className="column1">
            <div className="form-row">
              <div className="form-title">Project Name:</div>
              <div className="form-value">{props.projectName}</div>
            </div>
            <div className="form-row">
              <div className="form-title">Project Status:</div>
              <div className="form-value">
                {props.projectStatus ? props.projectStatus[0].toUpperCase() + props.projectStatus.slice(1) : null}
              </div>
            </div>
            <div className="form-row">
              <div className="form-title extend-tab1">Location:</div>
              <div className="form-value">
                &nbsp;&nbsp;&nbsp;&nbsp;{props.projectCounty}, {props.projectState}
              </div>
            </div>
          </div>
          <div className="column1">
            <div className="form-row">
              <div className="form-title">Designed by:&nbsp;&nbsp;</div>
              <div className="form-value">{emailToName(props.project.designedBy)}</div>
            </div>
            <div className="form-row">
              <div className="form-title">Checked by:&nbsp;&nbsp;&nbsp;</div>
              <div className={`form-value ${props.formData && props.formData.checkedByName ? '' : 'underline-value-13'}`}>
                {props.formData && props.formData.checkedByName ? props.formData.checkedByName : null}
              </div>
            </div>
            <div className="form-row">
              <div className="form-title">Approved by:&nbsp;</div>
              <div className={`form-value ${props.formData && props.formData.approvedByName ? '' : 'underline-value-13'}`}>
                {props.formData && props.formData.approvedByName ? props.formData.approvedByName : null}
              </div>
            </div>
          </div>
          <div className="column1">
            <div className="form-row ">
              <div className="form-title">Date:</div>
              <div className="form-value form-date-value">
                {props.project.lastChangedDate ? formatMonthDayYear2(props.project.lastChangedDate) : ''}
              </div>
            </div>
            <div className="form-row">
              <div className="form-title">Date:</div>
              <div className={`form-value form-date-value ${props.formData && props.formData.checkedByDate ? '' : 'underline-value-13'}`}>
                {props.formData && props.formData.checkedByDate ? formatMonthDayYear2(props.formData.checkedByDate) : ''}
              </div>
            </div>
            <div className="form-row">
              <div className="form-title">Date:</div>
              <div
                className={`form-value form-date-value ${props.formData && props.formData.approvedByDate ? '' : 'underline-value-13'}`}
              >
                {props.formData && props.formData.approvedByDate ? formatMonthDayYear2(props.formData.approvedByDate) : ''}
              </div>
            </div>
          </div>
        </div>
        <div className="light-teal-banner usa-summary-box">
          <div className="column">
            <div className="header">Waterway Name:</div>
            <div className="value">{props.waterwayName}</div>
          </div>
          <div className="column">
            <div className="header">Waterway Type:</div>
            <div className="value">{props.waterWayType}</div>
          </div>
          <div className="column">
            <div className="header">Hydro Project Name:</div>
            <div className="value">{waterwayDesignStore.selectedHydroProjectName}</div>
          </div>
          <div className="column">
            <div className="header peakQ">Peak FlowQ/Frequency:</div>
            <div className="value">{props.peakFlowQ}</div>
          </div>
          <div className="column">
            <div className="header">Alignment:</div>
            <div className="value">{props.alignmentName}</div>
          </div>
          <div className="column">
            <div className="header">Initial Q Fraction:</div>
            <div className="value">{props.initialQFraction}</div>
          </div>
          <div className="column">
            <div className="header">Channel Shape:&nbsp;&nbsp;&nbsp;</div>
            <div className="value">{props.channelShape}</div>
          </div>
        </div>
        <div className="button-header">Design Statistics</div>
        <div className="light-blue-border">
          <div className="form-columns">
            <div className="column col-md-4">
              <div className="row">
                <div className="form-title col nobr">Length (ft):</div>
                <div className="form-value col">{props.length?.toFixed(2)}</div>
              </div>
              <div className="row">
                <div className="form-title col nobr">Area (ac):</div>
                <div className="form-value col">{props.totalArea?.toFixed(2)}</div>
              </div>
              <div className="row">
                <div className="form-title col nobr">Total Cut (cy):</div>
                <div className="form-value col">{props.totalCut?.toFixed(2)}</div>
              </div>
            </div>
            <div className="column col-md-4">
              <div className="row">
                <div className="form-title col nobr">Total Fill (cy):</div>
                <div className="form-value col">{props.totalFill?.toFixed(2)}</div>
              </div>
              <div className="row">
                <div className="form-title col nobr">Cut/Fill Balance (cy):</div>
                <div className="form-value col">{props.cutFillBalance?.toFixed(2)}</div>
              </div>
            </div>
            <div className="column col-md-4">
              <div className="row">
                <div className="form-title col nobr">Additional Seeding Area (ac):</div>
                <div className="form-value col">{props.additionalSeedingArea?.toFixed(2)}</div>
              </div>
              <div className="row">
                <div className="form-title col nobr">Freeboard (ft):</div>
                <div className="form-value col">{waterwayDesignStore.globalFreeBoard}</div>
              </div>
            </div>
          </div>
        </div>
        <div className="button-header">{props.waterWayType === 'Lined Waterway' ? 'Lined' : 'Soil/Veg'}</div>
        <div className="veg-table">
          <Table className="usa-table usa-table--borderless wd-report-table">
            <thead>
              <tr className="narrow-td">
                <th className="narrow-td">Start Station</th>
                <th className="narrow-td">End Station</th>
                {props.waterWayType === 'Lined Waterway' ? (
                  <>
                    <th className="narrow-td">Lining Material</th>
                    <th className="narrow-td">Manning's n</th>
                    <th className="narrow-td">Thickness (in)</th>
                    <th className="narrow-td">Velocity (ft/s)</th>
                  </>
                ) : (
                  <>
                    <th className="narrow-td">Allowable Stress</th>
                    <th className="narrow-td">Soil Grain Roughness</th>
                    <th className="narrow-td">Vegetal Cover Factor</th>
                    <th className="narrow-td">Vegetal Cover Type</th>
                    <th className="narrow-td">Stability (RCI)</th>
                    <th className="narrow-td">Capacity (RCI)</th>
                    <th className="narrow-td">Velocity Stability (ft/s)</th>
                    <th className="narrow-td">Velocity Capacity (ft/s)</th>
                  </>
                )}
              </tr>
            </thead>
            <tbody>
              {props && list && list.length > 0
                ? list.map((obj: any, index) => (
                  <tr className="" key={'key-waterwayvertexParam--' + index}>
                    {true ? (
                      <>
                        <td className="narrow-tr">{obj.startStation}</td>
                        <td className="narrow-tr">{obj.endStation}</td>
                        {props.waterWayType === 'Lined Waterway' ? (
                          <>
                            <td className="narrow-tr">{obj.liningMaterial}</td>
                            <td className="narrow-tr">{obj.manningsN}</td>
                            <td className="narrow-tr">{obj.thickness}</td>
                            <td className="narrow-tr">{obj.velocity ? obj.velocity.toFixed(2) : null}</td>
                          </>
                        ) : (
                          <>
                            <td className="narrow-tr">
                              {obj.reachId === 'R-0' ? null : obj.soilStrength?.split('(')[0]}
                            </td>
                            <td className="narrow-tr">
                              {obj.reachId === 'R-0' ? null : obj.soilStrength?.split('(')[1].slice(0, -1)}
                            </td>
                            <td className="narrow-tr">
                              {obj.reachId === 'R-0' ? null : obj.vegetalCover?.split('(')[0]}
                            </td>
                            <td className="narrow-tr">
                              {obj.reachId === 'R-0' ? null : obj.vegetalCover?.split('(')[1].slice(0, -1)}
                            </td>
                            <td className="narrow-tr">{obj.reachId === 'R-0' ? null : obj.stability}</td>
                            <td className="narrow-tr">{obj.reachId === 'R-0' ? null : obj.capacity}</td>
                            <td className="narrow-tr">{obj.stabVelocity ? obj.stabVelocity.toFixed(2) : null}</td>
                            <td className="narrow-tr">{obj.capaVelocity ? obj.capaVelocity.toFixed(2) : null}</td>
                          </>
                        )}
                      </>
                    ) : null}
                  </tr>
                ))
                : null}
            </tbody>
          </Table>
        </div>

        <div className="button-header">Reaches Table</div>
        <div className="veg-table">
          <Table className="usa-table usa-table--borderless wd-report-table">
            <thead>
              <tr className="narrow-td">
                <th className="narrow-td">Status</th>
                <th className="narrow-td">Station</th>
                <th className="narrow-td">Reach</th>
                <th className="narrow-td">Ground Z (ft)</th>
                <th className="narrow-td">Channel Z (ft)</th>
                <th className="narrow-td">Cut Fill (ft)</th>
                <th className="narrow-td">%Slope</th>
                {props.channelShape === 'TRAPEZOIDAL' ? (
                  <>
                    <th className="narrow-td">Left SS (ft)</th>
                    <th className="narrow-td">Bottom Width (ft)</th>
                    <th className="narrow-td">Right SS (ft)</th>
                  </>
                ) : (
                  <>
                    <th className="narrow-td">Limiting slope (ft/ft)</th>
                    <th className="narrow-td">Offset 1 (%)</th>
                    <th className="narrow-td">Offset 2 (%)</th>
                    <th className="narrow-td">Offset 3 (%)</th>
                  </>
                )}

                <th className="narrow-td">Runoff Q (cfs)</th>
                <th className="narrow-td">Added Q (cfs)</th>
                <th className="narrow-td">Total Q (cfs)</th>
                <th className="narrow-td">Flow Depth (ft)</th>
                <th className="narrow-td">Flow TopWidth (ft)</th>
              </tr>
            </thead>
            <tbody>
              {props && reachList && reachList.length > 0
                ? reachList.map((obj: any, index) => (
                  <tr className="" key={'key-waterwayvertexParam--' + index}>
                    <td className="narrow-tr">
                      <div className="status-container">
                        <p
                          className={obj.status ? `status-label status--${obj.status}` : ''}
                          aria-label={`status-0`}
                          data-testid={`status-0`}
                        >
                          <span>{obj.status?.split('_')[0]}</span>
                        </p>
                      </div>
                    </td>
                    <td className="narrow-tr">{obj.endStation || obj.station}</td>
                    <td className="narrow-tr">{obj.reachId === 'R-0' ? null : obj.reachId}</td>
                    <td className="narrow-tr">
                      {obj.groundElev ? obj.groundElev.toFixed(2) : obj.groundZ ? obj.groundZ.toFixed(2) : null}
                    </td>
                    <td className="narrow-tr">
                      {obj.channelElev ? obj.channelElev.toFixed(2) : obj.channelZ ? obj.channelZ.toFixed(2) : null}
                    </td>
                    <td className="narrow-tr">{obj.cutFill ? obj.cutFill.toFixed(2) : null}</td>
                    <td className="narrow-tr">
                      {obj.grade ? (obj.grade * 100).toFixed(2) : obj.slope ? (obj.slope * 100).toFixed(2) : null}
                    </td>
                    <td className="narrow-tr">
                      {obj.channelParams?.leftSlopeRatio
                        ? obj.channelParams?.leftSlopeRatio
                        : obj.leftSS
                          ? obj.leftSS
                          : obj.limitSlope
                            ? obj.limitSlope
                            : null}
                    </td>
                    {props.channelShape === 'TRAPEZOIDAL' ? (
                      <>
                        <td className="narrow-tr">
                          {obj.channelParams?.minBedWidth
                            ? obj.channelParams?.minBedWidth.toFixed(2)
                            : obj.bottomWidth
                              ? obj.bottomWidth
                              : null}
                        </td>
                        <td className="narrow-tr">
                          {obj.channelParams?.rightSlopeRatio
                            ? obj.channelParams?.rightSlopeRatio
                            : obj.rightSS
                              ? obj.rightSS
                              : null}
                        </td>
                      </>
                    ) : (
                      <>
                        <td className="narrow-tr">{obj.channelParams?.offset1 | obj.offset1}</td>
                        <td className="narrow-tr">{obj.channelParams?.offset2 | obj.offset2}</td>
                        <td className="narrow-tr">{obj.channelParams?.offset3 | obj.offset3}</td>
                      </>
                    )}
                    <td className="narrow-tr">{obj.totalQ ? obj.totalQ.toFixed(2) : null}</td>
                    <td className="narrow-tr">{obj.addedQ}</td>
                    <td className="narrow-tr">{obj.totalQ ? obj.totalQ.toFixed(2) : null}</td>
                    <td className="narrow-tr">
                      {obj.depth ? obj.depth.toFixed(2) : obj.flowDepth ? obj.flowDepth : null}
                    </td>
                    <td className="narrow-tr">
                      {obj.width ? obj.width.toFixed(2) : obj.flowTopWidth ? obj.flowTopWidth : null}
                    </td>
                  </tr>
                ))
                : null}
            </tbody>
          </Table>
        </div>
      </div>
    </div>
  );
});
